// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { getDocument, isFunction } from "@nevware21/ts-utils";
import { _DYN_CREATE_EVENT } from "../__DynamicConstants";
export function createDomEvent(eventName) {
    var event = null;
    if (isFunction(Event)) { // Use Event constructor when available
        event = new Event(eventName);
    }
    else { // Event has no constructor in IE
        var doc = getDocument();
        if (doc && doc[_DYN_CREATE_EVENT /* @min:%2ecreateEvent */]) {
            event = doc[_DYN_CREATE_EVENT /* @min:%2ecreateEvent */]("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map